// extracted by mini-css-extract-plugin
module.exports = {"legend":"styles-module--legend--3g1rG","callout":"styles-module--callout--6-jjY","triangle":"styles-module--triangle--7kkFC"};